var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 159,
    viewBox: "0 0 118 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.927 45.4286H78.6667V3.54911C79.7934 4.37723 80.7153 5.20536 81.4323 6.03348L112.776 42.2344C113.493 43.0625 114.21 44.1272 114.927 45.4286ZM68.0769 0V48.2679C68.8333 50.6339 69.5503 52.6451 70.9844 54.3013C72.4184 55.9576 74.1597 56.7857 76.2083 56.7857H118V150.482C118 152.848 117.283 154.859 115.849 156.516C114.415 158.172 112.674 159 110.625 159H7.375C5.32639 159 3.58507 158.172 2.15104 156.516C0.717014 154.859 0 152.848 0 150.482V8.51786C0 6.15179 0.717014 4.14063 2.15104 2.48438C3.58507 0.828125 5.32639 0 7.375 0H68.0769Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 159,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDoc);
export default __webpack_public_path__ + "static/media/whiteDoc.1699882b3ad9288747084cc89d7a3240.svg";
export { ForwardRef as ReactComponent };